/* ppz-buybox.js — scelta della confezione e tipo di acquisto sulla scheda prodotto.
 *
 * Contratto: la scatola porta data-ppz-buy. Dentro:
 *   [data-ppz-bundle]        un bottone per confezione, con i prezzi gia' scritti
 *                            negli attributi data-* dal Liquid (formattati dal
 *                            filtro money: qui non si formattano valute a mano,
 *                            si scambiano solo stringhe pronte)
 *   [data-ppz-buy-variant]   l'input nascosto "id" che il form manda al carrello
 *   [data-ppz-buy-plan]      l'input nascosto "selling_plan" dell'abbonamento
 *   [data-ppz-once-price]    dove si scrive il prezzo dell'acquisto singolo
 *   [data-ppz-rooms]         la riga "N diffusori = N stanze"
 *
 * Nessuna chiamata di rete: tutti i prezzi delle varianti sono gia' in pagina.
 */
(function () {
  function init(root) {
    if (root.dataset.ppzBuy === 'ready') return;
    root.dataset.ppzBuy = 'ready';

    var bundles = Array.prototype.slice.call(root.querySelectorAll('[data-ppz-bundle]'));
    if (!bundles.length) return;

    var variantInput = root.querySelector('[data-ppz-buy-variant]');
    var form = root.querySelector('form');
    var rooms = root.querySelector('[data-ppz-rooms]');
    var roomsText = root.querySelector('[data-ppz-rooms-text]');
    var saveLabel = root.getAttribute('data-ppz-save-label') || '';
    /* «Prezzo a pezzo, totale nel pulsante» (06/10/2026): nei due riquadri
       abbonamento / acquisto singolo si scrive il prezzo di UN pezzo
       (data-kit, data-sub-kit, col barrato data-kit-full) e il totale della
       confezione va nel pulsante. data-price e data-sub-price restano i totali. */
    var kitMode = root.hasAttribute('data-ppz-kit-mode');
    /* Le righe dei regali sopra il pulsante (abbonamento acceso, 05/10/2026):
       ognuna dice da quanti pezzi in su compare. */
    var gifts = Array.prototype.slice.call(root.querySelectorAll('[data-ppz-gift-min]'));

    function setText(sel, value) {
      var el = root.querySelector(sel);
      if (el && value != null) el.textContent = value;
    }

    function show(sel, visible) {
      var el = root.querySelector(sel);
      if (el) el.hidden = !visible;
    }

    function selectedPurchase() {
      var checked = root.querySelector('input[name="ppz_purchase"]:checked');
      return checked ? checked.value : 'once';
    }

    /* Lo sconto di una confezione non e' un numero solo: e' uno per l'acquisto
       singolo e uno per l'abbonamento, tutti e due calcolati sullo STESSO prezzo
       barrato, quello pieno. Il Liquid li stampa gia' pronti negli attributi. */
    function savePct(bundle, sub) {
      return parseInt(bundle.getAttribute(sub ? 'data-save-sub' : 'data-save-once'), 10) || 0;
    }

    /* Le pillole si ridipingono TUTTE, non solo quella della confezione scelta:
       le tre si vedono insieme, e cambiando tipo di acquisto devono aggiornarsi
       tutte e tre nello stesso momento. */
    function paintSaves() {
      var sub = selectedPurchase() === 'sub';
      bundles.forEach(function (b) {
        var pill = b.querySelector('[data-ppz-bundle-save]');
        if (!pill) return;
        var pct = savePct(b, sub);
        pill.hidden = pct <= 0;
        if (pct > 0) pill.textContent = saveLabel ? saveLabel + ' ' + pct + '%' : pct + '%';
      });
    }

    /* Il campo dell'abbonamento si RICERCA OGNI VOLTA, non si tiene da parte.
       Motivo, letto nel codice dell'app degli abbonamenti (Kaching): il suo
       riquadro e' nascosto da custom.css, ma il suo JavaScript continua a
       girare e cerca [name="selling_plan"] DENTRO questo modulo, che e' il
       nostro campo. Se il suo riquadro ha un piano scelto ci scrive dentro
       quello; se sta su "acquisto singolo" lo CANCELLA dalla pagina.
       Tenendo un riferimento fisso finiremmo per scrivere su un campo staccato
       dal documento, e l'abbonamento non verrebbe inviato mai. Qui invece il
       campo si ricrea se sparisce, e ogni doppione altrui viene tolto. */
    function planField() {
      if (!form) return null;
      var mine = null;
      Array.prototype.slice.call(form.querySelectorAll('[name="selling_plan"]'))
        .forEach(function (el) {
          if (!mine && el.hasAttribute('data-ppz-buy-plan')) mine = el;
          else if (el.parentNode) el.parentNode.removeChild(el);
        });
      if (!mine) {
        mine = document.createElement('input');
        mine.type = 'hidden';
        mine.name = 'selling_plan';
        mine.setAttribute('data-ppz-buy-plan', '');
        form.appendChild(mine);
      }
      return mine;
    }

    /* L'input selling_plan va DISATTIVATO quando si compra una volta sola:
       un input disabilitato non viene inviato, quindi il carrello riceve un
       acquisto singolo e non un abbonamento. */
    function syncPlan(bundle) {
      var planInput = planField();
      if (!planInput) return;
      var planId = bundle.getAttribute('data-plan-id') || '';
      var wantsSub = selectedPurchase() === 'sub' && planId !== '';
      planInput.value = wantsSub ? planId : '';
      planInput.disabled = !wantsSub;
    }

    /* Il totale nel pulsante: quello del tipo d'acquisto scelto. Senza i due
       riquadri (abbonamento spento) selectedPurchase() dice «once», quindi e'
       il prezzo dell'acquisto singolo, come e' sempre stato. */
    function paintCta(bundle) {
      var sub = selectedPurchase() === 'sub';
      setText('[data-ppz-cta-price]', bundle.getAttribute(sub ? 'data-sub-price' : 'data-price'));
    }

    function apply(bundle, announce) {
      bundles.forEach(function (b) {
        b.setAttribute('aria-pressed', b === bundle ? 'true' : 'false');
      });

      if (variantInput) variantInput.value = bundle.getAttribute('data-variant-id') || '';

      var full = bundle.getAttribute(kitMode ? 'data-kit-full' : 'data-full');
      setText('[data-ppz-once-price]', bundle.getAttribute(kitMode ? 'data-kit' : 'data-price'));
      setText('[data-ppz-once-full]', full);
      setText('[data-ppz-sub-price]', bundle.getAttribute(kitMode ? 'data-sub-kit' : 'data-sub-price'));
      /* Il barrato dell'abbonamento e' suo (18/10/2026): data-sub-full / data-sub-kit-full, lo
         stesso sconto del singolo. Senza l'attributo resta quello unico. */
      setText('[data-ppz-sub-full]', bundle.getAttribute(kitMode ? 'data-sub-kit-full' : 'data-sub-full') || full);

      /* Il prezzo barrato ha senso solo se c'e' davvero uno sconto, e lo sconto
         non e' lo stesso nei due casi: chi si abbona risparmia di piu'. */
      show('[data-ppz-once-full]', savePct(bundle, false) > 0);
      show('[data-ppz-sub-full]', savePct(bundle, true) > 0);

      paintCta(bundle);
      paintSaves();

      var units = parseInt(bundle.getAttribute('data-units'), 10) || 1;
      if (rooms) rooms.setAttribute('data-units', units);

      /* Il regalo si vede solo con la confezione che lo da': guida da 2,
         spray da 3 (le soglie le scrive il Liquid, sono quelle del carrello). */
      gifts.forEach(function (g) {
        g.hidden = units < (parseInt(g.getAttribute('data-ppz-gift-min'), 10) || 1);
      });
      if (roomsText) {
        /* Singolare e plurale sono due frasi diverse: "1 diffusore = 1 stanza"
           contro "2 diffusori = 2 stanze". Le scrive il Liquid, qui si sceglie. */
        var attr = units === 1 ? 'data-template-one' : 'data-template';
        var tpl = roomsText.getAttribute(attr) || roomsText.getAttribute('data-template') || '';
        roomsText.textContent = tpl.split('{n}').join(units);
      }

      syncPlan(bundle);

      /* La galleria ascolta e rimette davanti la foto della confezione scelta.
         All'apertura della pagina non si annuncia niente: le foto sono gia'
         nell'ordine giusto e un riordino farebbe partire un'animazione a
         vuoto. */
      if (announce) {
        root.dispatchEvent(new CustomEvent('ppz:bundle', {
          detail: { units: units },
          bubbles: true
        }));
      }
    }

    function current() {
      var found = null;
      bundles.forEach(function (b) {
        if (b.getAttribute('aria-pressed') === 'true') found = b;
      });
      return found || bundles[0];
    }

    bundles.forEach(function (b) {
      b.addEventListener('click', function () { apply(b, true); });
    });

    /* Toccando la riga del regalo sotto una confezione si sceglie quella
       confezione (24/09/2026), tranne «Guarda anteprima», che apre la
       finestrella. La riga sta fuori dal bottone perche' contiene un altro
       bottone, e un bottone dentro un bottone non e' valido. */
    root.addEventListener('click', function (e) {
      var g = e.target.closest('.ppz-pack__gifts');
      if (!g || e.target.closest('[data-ppz-gift-open]')) return;
      var b = g.previousElementSibling;
      if (b && b.hasAttribute('data-ppz-bundle')) apply(b, true);
    });

    Array.prototype.slice.call(root.querySelectorAll('input[name="ppz_purchase"]'))
      .forEach(function (radio) {
        radio.addEventListener('change', function () {
          syncPlan(current());
          /* Cambiando acquisto singolo / abbonamento cambiano anche gli sconti
             mostrati sulle confezioni e il totale nel pulsante: vanno
             ridipinti subito. */
          paintSaves();
          paintCta(current());
        });
      });

    /* Ultimo controllo un attimo prima di partire: se nel frattempo l'app degli
       abbonamenti ha toccato il campo, qui torna al valore scelto dal cliente. */
    if (form) {
      form.addEventListener('submit', function () { syncPlan(current()); });
    }

    apply(current(), false);
  }

  function boot() {
    document.querySelectorAll('[data-ppz-buy]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
